/* eslint-disable no-unused-vars, no-redeclare */

import fetch from 'cross-fetch'

function blobToLoadedImage(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.addEventListener('error', () => {
      reject('fileReader error')
    })

    reader.addEventListener('load', (event) => {
      const image = new Image()

      image.addEventListener('error', () => {
        reject('image error')
      })
      image.addEventListener('load', () => {
        resolve(image)
      })

      image.src = event.target.result
    })

    reader.readAsDataURL(blob)
  })
}

function imageURLtoBlob(url) {
  return fetch(url).then((response) => response.blob())
}

function blobToImageData(blob) {
  var imageLoaded, fileReadError

  function fileRead() {
    var image = new Image()
    image.addEventListener('error', fileReadError)
    image.addEventListener('load', imageLoaded)
    image.src = this.result
  }

  function initPromise(resolve, reject) {
    imageLoaded = createImageLoadedResolver(resolve)
    fileReadError = createFileReadRejector(reject, blob)

    var reader = new FileReader()
    reader.addEventListener('error', fileReadError)
    reader.addEventListener('load', fileRead)
    reader.readAsDataURL(blob)
  }
  return new Promise(initPromise)
}

function createCanvasWithImageData(data) {
  var canvas = document.createElement('canvas')

  canvas.width = data.width
  canvas.height = data.height

  var ctx = canvas.getContext('2d')
  ctx.putImageData(data, 0, 0)

  return canvas
}

function createFileReadRejector(reject, blob) {
  return function fileReadError() {
    this.removeEventListener('error', fileReadError)
    reject(new Error('Could not read image from file ' + blob.name))
  }
}

function createImageLoadedResolver(resolve) {
  return function imageLoaded() {
    this.removeEventListener('load', imageLoaded)
    var canvas = document.createElement('canvas')

    canvas.width = this.naturalWidth
    canvas.height = this.naturalHeight

    var ctx = canvas.getContext('2d')
    ctx.drawImage(this, 0, 0)

    var data = ctx.getImageData(0, 0, this.naturalWidth, this.naturalHeight)
    resolve(data)
  }
}

function createImageLoadRejector(reject, isReadFromFile) {
  return function imageLoadError() {
    this.removeEventListener('error', imageLoadError)
    reject(new URIError('Could not load image by the URI ' + this.src))
  }
}

function imageDataToBlob(data, imageType, quality) {
  function initPromise(resolve, reject) {
    var canvas = createCanvasWithImageData(data)
    canvas.toBlob(resolve, 'image/' + (imageType || 'jpeg'), quality || 0.85)
  }
  return new Promise(initPromise)
}

function imageDataToDataURL(data, imageType, quality) {
  var canvas = createCanvasWithImageData(data)
  return canvas.toDataURL('image/' + (imageType || 'jpeg'), quality || 0.85)
}

function imageToImageData(image) {
  function initPromise(resolve, reject) {
    var imageLoaded = createImageLoadedResolver(resolve)
    var imageLoadError = createImageLoadRejector(reject)

    if (image.complete) {
      imageLoaded.bind(image)()
    } else {
      image.addEventListener('error', imageLoadError)
      image.addEventListener('load', imageLoaded)
    }
  }
  return new Promise(initPromise)
}

function URLToImageData(url) {
  var image = new Image()
  image.src = url
  return imageToImageData(image)
}

function flipRotateBase(imageData, transform) {
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  const newCanvas = document.createElement('canvas')
  const newContext = newCanvas.getContext('2d')

  canvas.width = imageData.width
  canvas.height = imageData.height

  context.putImageData(imageData, 0, 0)

  const { dx, dy, sw, sh } = transform(canvas, newCanvas, newContext)

  newContext.drawImage(canvas, dx, dy)

  return newContext.getImageData(0, 0, sw, sh)
}

export function rotate(imageData, degree) {
  return flipRotateBase(imageData, (canvas, newCanvas, newContext) => {
    let dx
    let dy

    newCanvas.width = canvas.height
    newCanvas.height = canvas.width

    newContext.rotate(degree * Math.PI / 180)

    if (degree === 90) {
      dx = 0
      dy = -newCanvas.width
    } else if (degree === 270) {
      dx = -newCanvas.height
      dy = 0
    } else {
      throw new Error('rotate: degree should be either 90 or 270')
    }

    return { dx, dy, sw: newCanvas.width, sh: newCanvas.height }
  })
}

export function flip(imageData, direction) {
  return flipRotateBase(imageData, (canvas, newCanvas, newContext) => {
    let dx
    let dy

    newCanvas.width = canvas.width
    newCanvas.height = canvas.height

    if (direction === 'horizontal') {
      newContext.scale(-1, 1)
      dx = -newCanvas.width
      dy = 0
    } else if (direction === 'vertical') {
      newContext.scale(1, -1)
      dx = 0
      dy = -newCanvas.height
    } else {
      throw new Error('flip: direction should be either vertical or horizontal')
    }

    return { dx, dy, sw: newCanvas.width, sh: newCanvas.height }
  })
}

export default {
  imageURLtoBlob,
  blobToLoadedImage,
  blobToImageData,
  imageDataToBlob,
  imageDataToDataURL,
  imageToImageData,
  URLToImageData
}
